import { pushEvent } from "@wbly/common";
import type { W, DataLayer } from "@wbly/common";
import type { CarouselEvent } from "../../../../../../../packages/ui/src/components/Carousel/types";

export const trackHeroEvent = (event: CarouselEvent) => {
  const { newPosition } = event;

  // Fire if user goes to second slide
  if (newPosition === 2) {
    pushEvent(
      (window as W)?.dataLayer as DataLayer[],
      "",
      "hero_banner_impression",
      `hero2`
    );
  }
};

export const trackHeroCta = (url: string, index: number) => {
  const slidePosition = index + 1;

  // At the time of writing, the requirement is only to track
  // events related to the first and second slides.
  if (slidePosition === 1 || slidePosition === 2) {
    pushEvent(
      (window as W)?.dataLayer as DataLayer[],
      "",
      "hero_banner_click",
      `hero${slidePosition}`,
      url
    );
  }
};

export const trackHeroLoad = () => {
  pushEvent(
    (window as W)?.dataLayer as DataLayer[],
    "",
    "hero_banner_impression",
    `hero1`
  );
};
